export const SliderData = [
    {
        image:"https://i.ibb.co/164GTJB/DB-1.png"
    },
    {
        image:"https://i.ibb.co/Bt5JM7C/DB-2.png" 
    },
    {
        image:"https://i.ibb.co/rKhmtLW/DB-3.png" 
    },
    {
        image:"https://i.ibb.co/DCZP6Q2/DB-4.png"
    }
];